/**
 * The sidebar's collapsed state: a saved wide-screen preference, and a phone
 * that always starts collapsed.
 */
export const SIDEBAR_KEY = "spm365.sidebar.collapsed";

export function readCollapsed(): boolean {
  let stored: string | null = null;
  try {
    stored = window.localStorage.getItem(SIDEBAR_KEY);
  } catch {
    // Storage unavailable: expanded on a wide screen, collapsed on a phone.
  }
  // A phone always starts collapsed, whatever was saved on a wider screen: an
  // expanded w-60 sidebar leaves a 375px screen about 100px of content, so
  // every table there would scroll sideways before it showed a second column.
  // The saved preference is a wide-screen preference.
  if (narrowViewport()) return true;
  return stored === "true";
}

function narrowViewport(): boolean {
  try {
    return window.matchMedia("(max-width: 767px)").matches;
  } catch {
    return false;
  }
}

export function writeCollapsed(collapsed: boolean): void {
  try {
    window.localStorage.setItem(SIDEBAR_KEY, String(collapsed));
  } catch {
    // A preference that could not be saved is not worth an error.
  }
}
